export const GET_ALL_AGENCY = 'GET_ALL_AGENCY'
export const GET_SINGLE_AGENCY = 'GET_SINGLE_AGENCY'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
